import { DELETE_COOKIES } from '../actions/main';
import { stateCookies as initialState } from '../initialState/main';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_COOKIES:
            return {
                state: true
            };
        default: return state;
    }
}

export default reducer;